import { ModalContainer } from "./BottomActionBarStyles";
import { Spacing } from "@vfuk/core-spacing";
import { createPortal } from "react-dom";
import { ReactNode } from "react";

type BottomActionBarProps = {
  children: ReactNode;
  buttons?: React.ReactElement;
};

const BottomActionBar = ({ children, buttons }: BottomActionBarProps) => {
  const footer = document.getElementById("bottomActionBar") as HTMLElement;

  if (!footer) {
    return null;
  }

  return (
    <>
      {createPortal(
        <ModalContainer>
          {children}
          <Spacing spacingLevel={{ top: 3, right: 6 }}>{buttons}</Spacing>
        </ModalContainer>,
        footer
      )}
    </>
  );
};

export default BottomActionBar;
